const enKundli = {
  // Errors & validation
  "please_fill_required_fields": "Please fill all required fields.",
  "invalid_email_format": "Enter a valid email address.",
  "invalid_phone_format": "Enter a valid phone number.",
  "payment_failed_message": "Payment failed. Try again or contact support.",

  // Header & hero
  "cosmic_career": "Personalized Kundli Report",
  "journey": "Your Complete Life Prediction",
  "discover_professional_destiny": "detailed astrology report with everything about your life path — delivered as PDF via WhatsApp or Email within 24 hours.",

  // Form labels
  "full_name": "Full Name",
  "enter_complete_name": "Enter your complete name",
  "gender": "Gender",
  "male": "Male",
  "female": "Female",
  "other": "Other",
  "email_address": "Email Address",
  "email_placeholder": "your@email.com",
  "phone_number": "Phone Number",
  "phone_placeholder": "+91 1234567890",
  "your_birth_date": "Birth Date",
  "birth_time": "Birth Time",
  "birth_place": "Birth Place",
  "city_state_country": "City, State, Country",
  "preferred_language": "Preferred Language",
  "english": "🇺🇸 English",
  "hindi": "🇮🇳 हिंदी",
  "telugu": "🇮🇳 తెలుగు",
  "kannada": "🇮🇳 ಕನ್ನಡ",
  "tamil": "🇮🇳 தமிழ்",
  "marathi": "🇮🇳 मराठी",
  "bengali": "🇮🇳 বাংলা",

  // Benefits (what you'll receive)
  "what_youll_receive": "✨ What You'll Get in Your Report",
  "life_kundali_20_years": "A detailed astrology report with everything about your life path.",
  "detailed_career_path_analysis": "Covers career, health, relationships, wealth, and remedies in detail.",
  "planetary_position_interpretations": "Includes charts, yogas, dashas, timelines, transits, and planetary positions explained clearly.",
  "dasha_system_predictions": "Easy-to-read sections with structured guidance and visual tables.",
  "personalized_remedial_suggestions": "Personalized remedies, gemstones, and suggestions for better results.",
  "digital_pdf_report": "Delivered as a PDF via WhatsApp or Email within 24 hours.",

  // Report formatting features
  "report_formatting_title": "📖 How the Report Looks",
  "clean_modern_formatting": "Clean and modern formatting.",
  "clear_tables_charts": "Clear tables, charts, and highlights for quick understanding.",
  "step_by_step_guidance": "Step-by-step predictions and remedies you can easily follow.",
  "professional_layout": "Professional layout designed for both mobile and desktop reading.",

  // Pricing/checkout
  "unlock_your_destiny_title": "Unlock Your Destiny",
  "complete_cosmic_journey_desc": "Fill your details & receive your personalized detailed astrology report.",
  "premium": "Premium Kundli Report",
  "career_path_analysis": "Complete Life Prediction Report",
  "processing_payment": "Processing payment...",
  "preparing_analysis": "Preparing your personalized report...",
  "complete_payment_get_report": "🚀 Complete Payment & Download Report",

  // Trust indicators
  "reports_generated": "15,000+ Reports Delivered",
  "rating": "Rated 4.9/5 by Users",
  "secure": "🔒 100% Safe & Secure Payment",

  // API / runtime messages
  "failed_to_load_payment": "Payment gateway could not load. Try again.",
  "failed_to_create_order": "Order creation failed. Please retry.",
  "failed_to_initialize_payment": "Payment initialization failed. Try again.",
  "failed_to_open_payment_gateway": "Could not open payment window. Retry again.",

  // Service details
  "birth_chart_analysis": "Personalized Life Report",
  "complete_kundli_report": " Vedic Astrology Report - All Life Areas Covered",
  "service_amount": "₹599",

  "advanced_astrology_suite": "Advanced Kundli Suite",
  "suite_summary": "Get an in-depth report with timelines, compatibility & structured insights — easy to read & share.",
  "feature_reports": "Comprehensive report with clear formatting & visual sections.",
  "feature_compatibility": "Compatibility analysis & life timelines for better decisions.",
  "feature_multilingual": "Supports multiple languages, device-friendly layout.",
  "report_preview_alt": "Report Preview",
  "get_my_report": "Get My Report",
  "autocomplete_hint": "Start typing your city; suggestions will appear"
};

export default enKundli;

// const enKundli = {
//   // Errors & validation
//   "please_fill_required_fields": "Please fill all required fields.",
//   "invalid_email_format": "Enter a valid email address.",
//   "invalid_phone_format": "Enter a valid phone number.",
//   "payment_failed_message": "Payment failed. Try again or contact support.",

//   // Header & hero
//   "cosmic_career": "Personalized Kundli Report",
//   "journey": "Your Complete Life Prediction",
//   "discover_professional_destiny": " Vedic astrology report covering career, health, relationships, wealth & remedies — delivered in 24 hours.",

//   // Form labels
//   "full_name": "Full Name",
//   "enter_complete_name": "Enter your complete name",
//   "gender": "Gender",
//   "male": "Male",
//   "female": "Female",
//   "other": "Other",
//   "email_address": "Email Address",
//   "email_placeholder": "your@email.com",
//   "phone_number": "Phone Number",
//   "phone_placeholder": "+91 1234567890",
//   "your_birth_date": "Birth Date",
//   "birth_time": "Birth Time",
//   "birth_place": "Birth Place",
//   "city_state_country": "City, State, Country",
//   "preferred_language": "Preferred Language",
//   "english": "🇺🇸 English",
//   "hindi": "🇮🇳 हिंदी",
//   "telugu": "🇮🇳 తెలుగు",
//   "kannada": "🇮🇳 ಕನ್ನಡ",
//   "tamil": "🇮🇳 தமிழ்",
//   "marathi": "🇮🇳 मराठी",
//   "bengali": "🇮🇳 বাংলা",

//   // Benefits (what you'll receive)
//   "what_youll_receive": "What’s Inside Your Report",
//   "life_kundali_20_years": "Comprehensive Kundli with  of life analysis covering career, health, wealth & relationships.",
//   "detailed_career_path_analysis": "Detailed charts, yogas, dashas, timelines & transits explained clearly.",
//   "planetary_position_interpretations": "Accurate planetary interpretations with structured & easy-to-read sections.",
//   "dasha_system_predictions": "Dasha & transit-based predictions to plan decisions with right timing.",
//   "personalized_remedial_suggestions": "Customized remedies, gemstone suggestions & practical guidance.",
//   "digital_pdf_report": "Beautifully designed digital PDF sent via WhatsApp or Email within 24 hours.",

//   // Pricing/checkout
//   "unlock_your_destiny_title": "Unlock Your Destiny",
//   "complete_cosmic_journey_desc": "Fill your details & receive your personalized  astrology report.",
//   "premium": "Premium Kundli Report",
//   "career_path_analysis": "Complete Life Prediction Report",
//   "processing_payment": "Processing payment...",
//   "preparing_analysis": "Preparing your personalized report...",
//   "complete_payment_get_report": "🚀 Complete Payment & Download Report",

//   // Trust indicators
//   "reports_generated": "15,000+ Reports Delivered",
//   "rating": "Rated 4.9/5 by Users",
//   "secure": "🔒 100% Safe & Secure Payment",

//   // API / runtime messages
//   "failed_to_load_payment": "Payment gateway could not load. Try again.",
//   "failed_to_create_order": "Order creation failed. Please retry.",
//   "failed_to_initialize_payment": "Payment initialization failed. Try again.",
//   "failed_to_open_payment_gateway": "Could not open payment window. Retry again.",

//   // Service details
//   "birth_chart_analysis": "Personalized Life Report",
//   "complete_kundli_report": " Vedic Astrology Report - All Life Areas Covered",
//   "service_amount": "₹599",

//   "advanced_astrology_suite": "Advanced Kundli Suite",
//   "suite_summary": "Get an in-depth report with timelines, compatibility & structured insights — easy to read & share.",
//   "feature_reports": "Comprehensive report with clear formatting & visual sections.",
//   "feature_compatibility": "Compatibility analysis & life timelines for better decisions.",
//   "feature_multilingual": "Supports multiple languages, device-friendly layout.",
//   "report_preview_alt": "Report Preview",
//   "get_my_report": "Get My Report",
//   "autocomplete_hint": "Start typing your city; suggestions will appear"
// };
// export default enKundli;

// const enKundli = {
//   // Errors & validation
//   "please_fill_required_fields": "Please fill in all required fields.",
//   "invalid_email_format": "Please enter a valid email address.",
//   "invalid_phone_format": "Please enter a valid phone number.",
//   "payment_failed_message": "Payment failed. Please try again or contact support.",

//   // Header & hero
//   "cosmic_career": " Kundli Report",
//   "journey": "Your Complete Life Analysis",
//   "discover_professional_destiny": "Personalized Vedic astrology report covering career, relationships, health, and remedies — delivered within 24 hours.",

//   // Form labels
//   "full_name": "Full Name",
//   "enter_complete_name": "Enter your complete name",
//   "gender": "Gender",
//   "male": "Male",
//   "female": "Female",
//   "other": "Other",
//   "email_address": "Email Address",
//   "email_placeholder": "your@email.com",
//   "phone_number": "Phone Number",
//   "phone_placeholder": "+91 1234567890",
//   "your_birth_date": "Your Birth Date",
//   "birth_time": "Birth Time",
//   "birth_place": "Birth Place",
//   "city_state_country": "City, State, Country",
//   "preferred_language": "Preferred Language",
//   "english": "🇺🇸 English",
//   "hindi": "🇮🇳 हिंदी",
//   "telugu": "🇮🇳 తెలుగు",
//   "kannada": "🇮🇳 ಕನ್ನಡ",
//   "tamil": "🇮🇳 தமிழ்",
//   "marathi": "🇮🇳 मराठी",
//   "bengali": "🇮🇳 বাংলা",

//   // Benefits (what you'll receive)
//   "what_youll_receive": "What You'll Receive",
//   "life_kundali_20_years": "Comprehensive Kundli with multi‑year timelines and guidance for career, relationships, health, and finances.",
//   "detailed_career_path_analysis": " PDF with charts, yogas, dashas, transits, and visual explanations.",
//   "planetary_position_interpretations": "Clear interpretations of planetary positions and houses with structured, easy‑to‑read sections.",
//   "dasha_system_predictions": "Dasha and transit‑based predictions to plan decisions with timing insights.",
//   "personalized_remedial_suggestions": "Personalized remedies and gemstone suggestions to balance challenging periods.",
//   "digital_pdf_report": "Digital PDF delivered via WhatsApp or Email within 24 hours.",

//   // Pricing/checkout
//   "unlock_your_destiny_title": "Get Your Full Report",
//   "complete_cosmic_journey_desc": "Complete the form and receive your personalized  astrology report.",
//   "premium": "Premium Report",
//   "career_path_analysis": "Complete Life Analysis Report",
//   "processing_payment": "Processing Payment...",
//   "preparing_analysis": "Generating Your  Report...",
//   "complete_payment_get_report": "🚀 Complete Payment & Get Report",

//   // Trust indicators
//   "reports_generated": "15,000+ Reports Delivered",
//   "rating": "4.9/5 Rated by Users",
//   "secure": "🔒 Safe & Secure Payment",

//   // API / runtime messages
//   "failed_to_load_payment": "Payment gateway failed to load. Please try again.",
//   "failed_to_create_order": "Unable to create order. Please retry.",
//   "failed_to_initialize_payment": "Failed to initialize payment. Try again shortly.",
//   "failed_to_open_payment_gateway": "Could not open payment window. Please try again.",

//   // Service details
//   "birth_chart_analysis": "Personalized Astrology Report",
//   "complete_kundli_report": " Vedic Kundli Report - All Life Areas Covered",
//   "service_amount": "₹599",

//   "advanced_astrology_suite": "Advanced Astrology Suite",
//   "suite_summary": "Generate polished, in-depth astrology reports with timelines, compatibility, and structured insights—ready to share and easy to understand.",
//   "feature_reports": "Comprehensive reports with clean formatting and visual sections for clarity.",
//   "feature_compatibility": "Compatibility analysis and timelines to support meaningful decisions.",
//   "feature_multilingual": "Multilingual output and device-friendly layouts for easy sharing.",
//   "report_preview_alt": "Report preview",
//   "get_my_report": "Get My Report",
//   "autocomplete_hint": "Start typing your city; suggestions will appear automatically"
// };
// export default enKundli;


// const enKundli = {
//   // Error Messages
//   "please_fill_required_fields": "Please fill in all required fields.",
//   "invalid_email_format": "Please enter a valid email address.",
//   "invalid_phone_format": "Please enter a valid phone number.",
//   "payment_failed_message": "Payment failed. Please try again or contact support.",

//   // Step Configuration
//   "personal_identity": "Personal Information",
//   "tell_us_about_yourself": "Tell us about yourself to begin",
//   "birth_details": "Birth Details",
//   "your_cosmic_coordinates": "We need your birth details to begin your analysis",
//   "time_and_place": "Time & Place of Birth",
//   "when_and_where_arrived": "When and where were you born?",
//   "your_preferences": "Language Preference",
//   "customize_experience": "Select your preferred language for the report",
//   "unlock_your_destiny": "Get Your  Kundli",
//   "complete_cosmic_journey": "Complete your details to receive the full report",

//   // Step 0: Personal Details
//   "who_are_you": "Who Are You?",
//   "start_with_basics": "Start by telling us the basics",
//   "full_name": "Full Name",
//   "enter_complete_name": "Enter your complete name",
//   "gender": "Gender",
//   "male": "Male",
//   "female": "Female",
//   "other": "Other",
//   "email_address": "Email Address",
//   "email_placeholder": "your@email.com",
//   "phone_number": "Phone Number",
//   "phone_placeholder": "+91 1234567890",

//   // Step 1: Birth Date
//   "your_birth_date": "Your Birth Date",
//   "cosmic_journey_begin": "When did your cosmic journey begin?",
//   "age_label": "Age",
//   "years": "years",

//   // Step 2: Time & Place
//   "time_and_place_title": "Time & Place of Birth",
//   "precise_moment_location": "The exact time and place ensure accurate calculations",
//   "birth_time": "Birth Time",
//   "select_exact_time": "Select your exact birth time",
//   "birth_place": "Birth Place",
//   "city_state_country": "City, State, Country",
//   "location_accuracy": "Location Accuracy",
//   "exact_birthplace_ensures": "Exact birthplace ensures precise planetary positions",

//   // Step 3: Preferences
//   "your_preferences_title": "Choose Language",
//   "customize_astrological_experience": "Select the language for your personalized report",
//   "preferred_language": "Preferred Language",
//   "english": "🇺🇸 English",
//   "hindi": "🇮🇳 हिंदी",
//   "telugu": "🇮🇳 తెలుగు",
//   "kannada": "🇮🇳 ಕನ್ನಡ",
//   "tamil": "🇮🇳 தமிழ்",
//   "marathi": "🇮🇳 मराठी",
//   "bengali": "🇮🇳 বাংলা",
//   "what_youll_receive": "What You'll Receive",
//   "life_kundali_20_years": "Life Kundali with 20 Years of Future Predictions — Year-by-Year Guidance for Career, Love, Health & Wealth",
//   "detailed_career_path_analysis": " PDF Kundli Report",
//   "planetary_position_interpretations": "Covers 20+ astrological systems",
//   "dasha_system_predictions": "Includes Career, Marriage, Health & Life Predictions",
//   "personalized_remedial_suggestions": "Personalized Remedies & Gemstone Suggestions",
//   "digital_pdf_report": "Delivered via WhatsApp or Email within 24 Hours",

//   // Step 4: Payment
//   "unlock_your_destiny_title": "Get Your Full Report",
//   "complete_cosmic_journey_desc": "Complete the form and receive your personalized  astrology report",
//   "premium": "Premium Report",
//   "career_path_analysis": "Complete Life Analysis Report",
//   "off_label": "OFF",
//   "summary_of_details": "Your Summary:",
//   "name_label": "Name:",
//   "birth_date_label": "Birth Date:",
//   "birth_time_label": "Birth Time:",
//   "birth_place_label": "Birth Place:",
//   "processing_payment": "Processing Payment...",
//   "preparing_analysis": "Generating Your  Report...",
//   "complete_payment_get_report": "🚀 Complete Payment & Get Report",

//   // Navigation
//   "previous": "← Previous",
//   "step_of": "Step",
//   "of": "of",
//   "next": "Next →",
//   "review_and_pay": "Review & Pay",

//   // Validation Messages
//   "fill_personal_details": "Please fill in all required personal details",
//   "select_birth_date": "Please select your birth date",
//   "provide_birth_time_place": "Please provide accurate birth time and place",

//   // Header
//   "cosmic_career": " Kundli Report",
//   "journey": "Your Complete Life Analysis",
//   "discover_professional_destiny": "Get your personalized Vedic astrology report with career, love, health and remedies—delivered in 24 hours.Life Kundali with 20 Years of Future Predictions — Year-by-Year Guidance for Career, Love, Health & Wealth",

//   // Trust Indicators
//   "reports_generated": "15,000+ Reports Delivered",
//   "rating": "4.9/5 Rated by Users",
//   "secure": "🔒 Safe & Secure Payment",

//   // Thank You Page Service Features
//   "detailed_career_guidance_pdf": "Complete Career & Life Path Guidance",
//   "comprehensive_astrological_analysis": "Based on 20+ Astrology Systems",
//   "planetary_positions_interpretations": "Includes Dasha, Gochar, Nakshatra, Numerology",
//   "dasha_system_predictions_feature": "Future Predictions, Planetary Timelines",
//   "personalized_remedial_suggestions_feature": "Custom Remedies, Gemstones & Dosha Reports",

//   // API Related Messages
//   "failed_to_load_payment": "Payment gateway failed to load. Please try again.",
//   "failed_to_create_order": "Unable to create order. Please retry.",
//   "failed_to_initialize_payment": "Failed to initialize payment. Try again shortly.",
//   "failed_to_open_payment_gateway": "Could not open payment window. Please try again.",

//   // Service Details
//   "birth_chart_analysis": "Personalized Astrology Report",
//   "complete_kundli_report": " Vedic Kundli Report - All Life Areas Covered",
//   "service_amount": "₹599",

//   // Time of Day Indicators (for emoji display)
//   "morning": "🌅",
//   "afternoon": "☀️",
//   "evening": "🌆",
//   "night": "🌙",

//   // Days of Week
//   "monday": "Monday",
//   "tuesday": "Tuesday", 
//   "wednesday": "Wednesday",
//   "thursday": "Thursday",
//   "friday": "Friday",
//   "saturday": "Saturday",
//   "sunday": "Sunday",

//   // Months
//   "january": "January",
//   "february": "February",
//   "march": "March",
//   "april": "April",
//   "may": "May",
//   "june": "June",
//   "july": "July",
//   "august": "August",
//   "september": "September",
//   "october": "October",
//   "november": "November",
//   "december": "December"
// };
// export default enKundli;
